/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import styles from './LiveChatButton.style';
import BellIcon from 'src/shared/ui/component/icon/Bell2Icon';
import BellSleepingIcon from 'src/shared/ui/component/icon/BellSleepingIcon';
import messages from 'plugin/live-chat/l10n/liveChatL10n';
import { LIVE_CHAT_STATUS_OFFLINE } from 'plugin/live-chat/constant/liveChatConstant';
import { toggleLiveChat } from 'plugin/live-chat/util/liveChatUtils';
import { getStatus } from 'plugin/live-chat/selector/liveChatSelectors';

const useStyles = createUseStyles(styles);

const LiveChatButton = (): React.Node => {
  const intl = useIntl();
  const status = useSelector(getStatus);
  const classes: Object = useStyles();

  const handleClick = () => {
    toggleLiveChat();
  };

  return (
    <div onClick={handleClick} className={classes.root}>
      {status === LIVE_CHAT_STATUS_OFFLINE ? (
        <>
          <div className={classes.icon}>
            <BellSleepingIcon />
          </div>
          {intl.formatMessage(messages.talkOfflineButton)}
        </>
      ) : (
        <>
          <div className={classes.icon}>
            <BellIcon />
          </div>
          {intl.formatMessage(messages.talkButton)}
        </>
      )}
    </div>
  );
};

export default compose(React.memo)(LiveChatButton);
